import React, { FC } from 'react';
import { AuthCallback } from '~/components';

const MerchantInviteAuthCallback: FC = () => <AuthCallback flowKey="invite-signup" />;

export default MerchantInviteAuthCallback;
